module.exports = __webpack_public_path__ + "img/third-onboarding-banner.882649cb.png";